// 菜单动作
export const replyTxtType = 1; // 文本消息
export const replyImgType = 2; // 图片消息
export const replyImgTxtType = 3; // 图文消息
export const replyAppletPluginType = 10; // 小程序卡片

export const REPLY_TXT_TYPE = replyTxtType;
export const REPLY_IMG_TYPE = replyImgType;
export const REPLY_IMG_TXT_TYPE = replyImgTxtType;
export const REPLY_APPLET_PLUGIN_TYPE = replyAppletPluginType;
